import { createReducer, INITIAL_STATE } from '@shared/redux';

export const BUDGET_MANAGER_TABLE_SWITCH_TOOGLE = '@budget-manager/table/switch/BUDGET_MANAGER_TABLE_SWITCH_TOOGLE';

export const
    isBudgetManagerTableSwitchActive = state => state.budgetManager?.table?.isSwitchActive;

export const setBudgetManagerTableSwitchToggle = (toogle: boolean) => ({
    type: BUDGET_MANAGER_TABLE_SWITCH_TOOGLE,
    payload: {
        toogle,
    },
});

const initialState = {
    isSwitchActive: false,
};

export const obmSegmentsTableReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [BUDGET_MANAGER_TABLE_SWITCH_TOOGLE]: (state, action) => ({
        ...state,
        isSwitchActive: action.payload.toogle,
    }),
});
